import { ClientDataType, setKeyId, setKeyLogin, setKeyValue, setWebsite } from "../../../redux/slices/wikiKeysSlice";

export const isCompany = (client: ClientDataType) => {
    return client.userRole === 3 && client.clientType === 2;
};

export const resetKeyData = dispatch => {
    dispatch(setKeyLogin(''));
    dispatch(setKeyValue(''));
    dispatch(setWebsite(''));
    dispatch(setKeyId(''));
  };
